export const EMPTY_SHORTS_STATS = {
  steps: null,
  distanceKm: null,
  fun: null,
  fatigue: null,
};

function parseOptionalNumber(value) {
  if (value === '' || value === null || value === undefined) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function normalizeShortsStats(raw) {
  if (!raw || typeof raw !== 'object') {
    return { ...EMPTY_SHORTS_STATS };
  }
  const steps = parseOptionalNumber(raw.steps);
  const distanceKm = parseOptionalNumber(raw.distanceKm);
  let fun = parseOptionalNumber(raw.fun);
  let fatigue = parseOptionalNumber(raw.fatigue);
  if (fun != null) fun = Math.min(10, Math.max(0, Math.round(fun)));
  if (fatigue != null) fatigue = Math.min(10, Math.max(0, Math.round(fatigue)));
  return {
    steps: steps != null ? Math.max(0, Math.round(steps)) : null,
    distanceKm: distanceKm != null ? Math.max(0, distanceKm) : null,
    fun,
    fatigue,
  };
}

/** Cumulative stats for days 0..throughDayIndex (inclusive). */
export function computeTripStatsTotals(days, throughDayIndex) {
  if (!days?.length || throughDayIndex < 0) {
    return {
      totalSteps: null,
      totalKm: null,
      avgFun: null,
      avgFatigue: null,
      tripDayNumber: 0,
      totalDays: days?.length || 0,
    };
  }

  let totalSteps = 0;
  let totalKm = 0;
  let hasSteps = false;
  let hasKm = false;
  let funSum = 0;
  let funCount = 0;
  let fatigueSum = 0;
  let fatigueCount = 0;

  const end = Math.min(throughDayIndex, days.length - 1);
  for (let i = 0; i <= end; i++) {
    const s = normalizeShortsStats(days[i].shortsStats);
    if (s.steps != null) {
      totalSteps += s.steps;
      hasSteps = true;
    }
    if (s.distanceKm != null) {
      totalKm += s.distanceKm;
      hasKm = true;
    }
    if (s.fun != null) {
      funSum += s.fun;
      funCount += 1;
    }
    if (s.fatigue != null) {
      fatigueSum += s.fatigue;
      fatigueCount += 1;
    }
  }

  return {
    totalSteps: hasSteps ? totalSteps : null,
    totalKm: hasKm ? totalKm : null,
    avgFun: funCount > 0 ? funSum / funCount : null,
    avgFatigue: fatigueCount > 0 ? fatigueSum / fatigueCount : null,
    tripDayNumber: end + 1,
    totalDays: days.length,
  };
}

export function formatSteps(value) {
  if (value == null) return '—';
  const n = Math.round(Number(value));
  if (n >= 1000) {
    const k = n / 1000;
    if (n % 1000 === 0) {
      return `${k}K`;
    }
    const rounded = Math.round(k * 10) / 10;
    return `${rounded}K`;
  }
  return n.toLocaleString('en-US');
}

export function formatKm(value) {
  if (value == null) return '—';
  return Number(value).toLocaleString('en-US', {
    maximumFractionDigits: 1,
    minimumFractionDigits: 0,
  });
}

export function formatMeter(value) {
  if (value == null) return '—';
  return `${Math.round(value)}/10`;
}

export function formatTripAvgCeil(value) {
  if (value == null) return null;
  return String(Math.ceil(Number(value)));
}

export function countDayAttractions(day) {
  if (!day?.activities) return 0;
  return day.activities.filter((a) => a.type === 'attraction').length;
}

const FUN_EMOJI = ['😢', '😕', '😐', '🙂', '😊', '😄', '😁', '🤗', '😍', '🤩', '🥳'];
const FATIGUE_EMOJI = ['😌', '🙂', '😐', '😑', '😓', '😩', '😫', '🥱', '😵', '🛌', '💤'];

export function getFunEmoji(value) {
  if (value == null || value === '') return '❔';
  const v = Math.min(10, Math.max(0, Math.round(Number(value))));
  return FUN_EMOJI[v];
}

export function getFatigueEmoji(value) {
  if (value == null || value === '') return '❔';
  const v = Math.min(10, Math.max(0, Math.round(Number(value))));
  return FATIGUE_EMOJI[v];
}

export { FUN_EMOJI as FUN_EMOJI_ROW, FATIGUE_EMOJI as FATIGUE_EMOJI_ROW };
